import * as THREE from "three";
import { Context } from "../core/context";
import {
  DBEntity,
  DbLine,
  DbMesh,
  SceneManager,
  ViewManager,
} from "@/CadEngine";
import {
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
  IModifyOperation,
  ModifyOperateState,
} from "./IModifyOperation";
import { ULabel } from "@/ui/ULabel";
import {
  CommonColor,
  Linearity,
  SampleLayerType,
  SlopeAnnotationModifyReturnData,
} from "@/core/Parameters";
import { DimensionGroup } from "@/core/DimensionGroup";

class SlopeAnnotationModify implements IModifyOperation {
  private m_context: Context;
  private m_points: THREE.Vector3[] = [];
  private curPoint: THREE.Vector3 = new THREE.Vector3();
  private m_dimension: DimensionGroup;
  private m_locationObject: THREE.Line;
  private m_TextLabel: ULabel;
  private m_select: DbLine | undefined;
  private m_scale = 1;
  private m_isDraw = false;
  private m_auxLineGroupCurrent: THREE.Group = new THREE.Group();
  private m_auxLineInsertSignGroupCurrent: THREE.Group = new THREE.Group();
  private m_currentAuxLine: THREE.Line | undefined;
  private m_auxLineStartPoint: THREE.Vector3 | undefined;
  private m_slopeLine: THREE.LineSegments | undefined;
  private m_slopeLineArrow: THREE.Mesh | undefined;
  private m_returnData: SlopeAnnotationModifyReturnData = {
    line: { start: new THREE.Vector3(), end: new THREE.Vector3() },
    arrowPoints: [],
    directionVector: new THREE.Vector3(),
    selectObject: undefined,
  };
  private m_selectLine3: THREE.Line3 | undefined;
  private m_callbackUnderway: (point: THREE.Vector3) => void;
  private m_TextLabelLocation: THREE.Vector3 = new THREE.Vector3();
  private m_isShift: Boolean = false;

  constructor(
    context: Context,
    callbackUnderway: (point: THREE.Vector3) => void
  ) {
    this.m_context = context;
    this.m_callbackUnderway = callbackUnderway;

    this.m_dimension = new DimensionGroup(
      context.ViewManager,
      context.SceneManager.AuxModel
    );
    this.m_locationObject = context.ToolsManager.CreatedLocationLine();
    this.m_TextLabel = new ULabel(
      this.m_context.ViewManager,
      this.m_context.Dom
    );
    this.m_TextLabel.Visibility = true;
    this.m_context.SceneManager.AuxModel.add(
      this.m_auxLineGroupCurrent,
      this.m_auxLineInsertSignGroupCurrent
    );
    this.m_scale = this.m_context.ViewManager.ScreenModelScale;
  }

  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void {}
  OnMovePoint(point: DrawOperationMovePointParams): void {
    this.curPoint = point.point;
    this.m_locationObject.position.copy(this.curPoint);
    if (this.m_points.length >= 2) return;
    this.m_TextLabelLocation.x = this.curPoint.x + this.m_scale * 55;
    this.m_TextLabelLocation.y = this.curPoint.y - this.m_scale * 10;

    if (this.m_isDraw && this.m_auxLineStartPoint) {
      this.m_TextLabel.SetVaule(
        "请选择方向,长按Shift锁定正交",
        this.m_TextLabelLocation,
        new THREE.Vector3(1, 0, 0)
      );
      if (this.m_isShift && this.m_points.length) {
        this.curPoint = this.m_context.ToolsManager.GetOrthogonalityPoint(
          this.curPoint,
          this.m_points[this.m_points.length - 1]
        );
      }
      this.m_currentAuxLine?.geometry.setFromPoints([
        this.m_auxLineStartPoint,
        this.curPoint,
      ]);
      this.m_currentAuxLine?.computeLineDistances();
      this.drawTempLine();
    } else {
      this.m_TextLabel.SetVaule(
        "请选择要操作的管线,长按Shift锁定正交",
        this.m_TextLabelLocation,
        new THREE.Vector3(1, 0, 0)
      );
    }
  }
  OnDownPoint(point: DrawOperationMovePointParams): void {
    if (!this.m_isDraw) {
      if (point.obejct && point.obejct[0] instanceof DbLine) {
        this.m_select = point.obejct[0] as DbLine;
        let estimateResult = this.m_context.ToolsManager.EstimateSelectType(
          this.m_select,
          [SampleLayerType.Line],
          [Linearity.Continuous, Linearity.Dash]
        );
        if (estimateResult) {
          this.createAuxLine();
          this.createSlopeLine();
          this.createSlopeLineArrow();
          this.m_context.SelectionManager.ClearSelected();
          this.m_context.SelectionManager.SetSelected(this.m_select);
          this.m_isDraw = true;
          this.m_auxLineStartPoint = this.curPoint.clone();
          this.m_points.push(this.curPoint.clone());
        } else {
          this.m_select = undefined;
        }
      }
    } else {
      if (this.m_points.length == 1) {
        this.m_points.push(this.curPoint.clone());
        this.m_callbackUnderway(this.curPoint.clone());
        this.m_TextLabel.SetVaule(
          "请结束操作",
          this.m_TextLabelLocation,
          new THREE.Vector3(1, 0, 0)
        );
      }
      // this.m_context.ModifyManager.ModifyFinish(ModifyOperateState.complete);
    }
  }
  onKeyDown(e: KeyboardEvent): void {
    if (e.keyCode == 16) {
      this.m_isShift = true;
    }
  }
  onKeyUp(e: KeyboardEvent): void {
    if (e.keyCode == 16) {
      this.m_isShift = false;
    }
  }

  OnZoom(camera: THREE.Camera): void {}

  Finish(operate: ModifyOperateState) {
    this.clear();
    if (operate == ModifyOperateState.complete) {
      if (this.m_points.length) {
        this.m_returnData.directionVector = this.m_points[1]
          .clone()
          .sub(this.m_points[0]);
        this.m_returnData.selectObject = this.m_select;
      }

      return this.m_returnData;
    } else if (operate == ModifyOperateState.cancel) {
      return [];
    }
  }
  OnWheel(e: WheelEvent): void {
    this.m_scale = this.m_context.ViewManager.ScreenModelScale;
  }

  onMouseMove(e?: PointerEvent): void {
    if (this.m_select) {
      this.m_context.SelectionManager.ClearSelected();
      this.m_context.SelectionManager.SetSelected(this.m_select);
    }
  }

  onMouseDown(e: PointerEvent): void {
    if (this.m_select) {
      this.m_context.SelectionManager.ClearSelected();
      this.m_context.SelectionManager.SetSelected(this.m_select);
    }
    if (e.button !== 0) return;
  }

  onMouseUp(e: PointerEvent): void {
    if (this.m_select) {
      this.m_context.SelectionManager.ClearSelected();
      this.m_context.SelectionManager.SetSelected(this.m_select);
    }
    if (e.button !== 0) return;
  }

  private createAuxLine() {
    this.m_currentAuxLine = this.m_context.ToolsManager.CreatedAuxLine();
    this.m_currentAuxLine.frustumCulled = false;
    this.m_auxLineGroupCurrent.add(this.m_currentAuxLine);
  }

  private createSlopeLine() {
    let geo = new THREE.BufferGeometry();
    geo.setFromPoints([
      new THREE.Vector3(-0.75, 0, 0),
      new THREE.Vector3(0.75, 0, 0),
    ]);
    let mat = new THREE.LineBasicMaterial({ color: CommonColor.White });
    let slopeLine = new THREE.LineSegments(geo, mat);
    slopeLine.frustumCulled = false;
    this.m_slopeLine = slopeLine;
    this.m_auxLineInsertSignGroupCurrent.add(slopeLine);
    this.m_slopeLine.visible = false;
  }
  private createSlopeLineArrow() {
    let geo = new THREE.BufferGeometry();
    const indices = new Uint16Array([0, 1, 2]);
    geo.setIndex(new THREE.BufferAttribute(indices, 1));
    let mat = new THREE.MeshBasicMaterial({
      color: CommonColor.White,
      side: THREE.DoubleSide,
    });
    let SlopeLineArrow = new THREE.Mesh(geo, mat);
    SlopeLineArrow.frustumCulled = false;
    this.m_slopeLineArrow = SlopeLineArrow;
    this.m_auxLineInsertSignGroupCurrent.add(SlopeLineArrow);
    this.m_slopeLineArrow.visible = false;
  }

  private drawTempLine() {
    this.m_slopeLine!.visible = true;
    this.m_slopeLineArrow!.visible = true;
    let xAxis = new THREE.Vector3(1, 0, 0);
    let zAxis = new THREE.Vector3(0, 0, 1);
    let selectLinePoints = this.m_select?.points!;
    let selectLineStartP = new THREE.Vector3(
      selectLinePoints[0],
      selectLinePoints[1],
      selectLinePoints[2]
    );
    let selectLineEndP = new THREE.Vector3(
      selectLinePoints[3],
      selectLinePoints[4],
      selectLinePoints[5]
    );
    this.m_selectLine3 = new THREE.Line3(selectLineStartP, selectLineEndP);

    let handleP = selectLineStartP.clone();
    if (
      selectLineStartP.distanceTo(this.curPoint) >
      selectLineEndP.distanceTo(this.curPoint)
    ) {
      handleP = selectLineEndP.clone();
    }
    let handleVector = handleP
      .clone()
      .sub(this.m_auxLineStartPoint!)
      .normalize();
    let currentVector = this.curPoint
      .clone()
      .sub(this.m_auxLineStartPoint!)
      .normalize();

    let AngleOfXAxis = handleVector.angleTo(xAxis);
    if (handleVector.clone().cross(xAxis).z > 0) {
      AngleOfXAxis = -AngleOfXAxis;
    }
    let CAndHCross = currentVector.clone().cross(handleVector).z;
    let verticalVet = handleVector
      .clone()
      .applyAxisAngle(zAxis, -Math.PI / 2)
      .setLength(0.1);
    if (CAndHCross < 0) {
      verticalVet = handleVector
        .clone()
        .applyAxisAngle(zAxis, Math.PI / 2)
        .setLength(0.1);
    }
    let offset = this.m_auxLineStartPoint!.clone().add(verticalVet);
    let q = new THREE.Quaternion();
    q.setFromAxisAngle(zAxis, AngleOfXAxis);
    this.updateSlopeLinePosition(offset, q);
  }

  private updateSlopeLinePosition(offset: THREE.Vector3, q: THREE.Quaternion) {
    let slopeLinePoint1 = new THREE.Vector3(-0.75, 0, 0);
    let slopeLinePoint2 = new THREE.Vector3(0.75, 0, 0);
    slopeLinePoint1.applyQuaternion(q).add(offset);
    slopeLinePoint2.applyQuaternion(q).add(offset);
    this.m_slopeLine?.geometry.setFromPoints([
      slopeLinePoint1,
      slopeLinePoint2,
    ]);
    this.m_returnData.line = {
      start: slopeLinePoint1.clone(),
      end: slopeLinePoint2.clone(),
    };
    this.updateArrowPosition(slopeLinePoint1, slopeLinePoint2);
  }
  private updateArrowPosition(p1: THREE.Vector3, p2: THREE.Vector3) {
    let zAxis = new THREE.Vector3(0, 0, 1);
    let handleP = p1.clone();
    let handleVector = p1.clone().sub(p2);
    if (p1.distanceTo(this.curPoint) > p2.distanceTo(this.curPoint)) {
      handleP = p2.clone();
      handleVector = p2.clone().sub(p1);
    }
    // let curPToHandPVector = this.curPoint.clone().sub(handleP);
    // let cross = curPToHandPVector.clone().cross(handleVector).z;

    let selectTargetP = new THREE.Vector3();
    this.m_selectLine3!.closestPointToPoint(this.curPoint, true, selectTargetP);
    let vec1 = selectTargetP.clone().sub(this.m_auxLineStartPoint!);
    let vec2 = this.curPoint.clone().sub(this.m_auxLineStartPoint!);
    let cross = vec2.clone().cross(vec1).z;

    let arrowPoint1 = handleVector.clone().negate().setLength(0.3).add(handleP);
    let arrowPoint1ToHandlePVec = handleP.clone().sub(arrowPoint1);
    let arrowPoint2 = arrowPoint1ToHandlePVec
      .clone()
      .applyAxisAngle(zAxis, -Math.PI / 2)
      .setLength(0.04)
      .add(arrowPoint1);
    if (cross < 0) {
      arrowPoint2 = arrowPoint1ToHandlePVec
        .clone()
        .applyAxisAngle(zAxis, Math.PI / 2)
        .setLength(0.04)
        .add(arrowPoint1);
    }
    let tempP = arrowPoint1ToHandlePVec
      .clone()
      .applyAxisAngle(zAxis, Math.PI / 2)
      .setLength(0.04)
      .add(arrowPoint1);
    if (cross < 0) {
      tempP = arrowPoint1ToHandlePVec
        .clone()
        .applyAxisAngle(zAxis, -Math.PI / 2)
        .setLength(0.04)
        .add(arrowPoint1);
    }
    arrowPoint1 = tempP.clone();
    this.m_slopeLineArrow?.geometry.setFromPoints([
      arrowPoint1,
      arrowPoint2,
      handleP,
    ]);
    this.m_returnData.arrowPoints = [arrowPoint1, arrowPoint2, handleP];
  }

  private clear() {
    this.m_context.ToolsManager.GroupClear(
      this.m_auxLineInsertSignGroupCurrent
    );
    this.m_context.ToolsManager.GroupClear(this.m_auxLineGroupCurrent);
    this.m_context.ToolsManager.ObjectsClear([
      this.m_locationObject,
      this.m_currentAuxLine!,
    ]);

    this.m_dimension?.dispose();
    this.m_TextLabel?.dispose();
  }
}

export { SlopeAnnotationModify };
